(function () {
    'use strict';

    
    angular
        .module('aircraftRegistration')
        .service('AircraftRegistrationService', AircraftRegistrationService);

    function AircraftRegistrationService(AircraftRegistrationRequestFactory,RemoteService, ApplicationService) {
        var self = this;

        var model={
        	acRegSearchCriteria: AircraftRegistrationRequestFactory.getAcRegSearchCriteria(),
            aircraftList:[],
            capacity:AircraftRegistrationRequestFactory.getCapacity()
        };

        self.setAcRegSearchCriteria = function (passAcRegSearch) {
            var acRegSearch = AircraftRegistrationRequestFactory.getAcRegSearchCriteria();
            acRegSearch.modelNumber = ( passAcRegSearch.acModel == null ? null : passAcRegSearch.acModel.modelNumber );
            acRegSearch.startPosition = passAcRegSearch.startPosition;
            acRegSearch.pageSize = passAcRegSearch.pageSize;
            acRegSearch.aircraftRegName = passAcRegSearch.aircraftRegName;
            acRegSearch.status = passAcRegSearch.status.value;
            acRegSearch.inActiveStartDate = passAcRegSearch.inActiveStartDate;
            acRegSearch.etop = passAcRegSearch.etop;
            acRegSearch.sharklets = passAcRegSearch.sharklets;
            acRegSearch.capacity = passAcRegSearch.capacity;
            model.acRegSearchCriteria = acRegSearch;
            
        };

        
        self.getAcRegistration = function(successFn, errorFn){
            RemoteService.searchAircraftRegistration(model.acRegSearchCriteria).then(
                function (response) {
                    if(response.success){
                        model.aircraftList = response.aircraftRegAdaptDTOs;
                        successFn(model.aircraftList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.getNewReg = function () {
            return AircraftRegistrationRequestFactory.getNewAirCraftRegForEdit();
        };
        
        self.getNewAcRegPeriod = function () {
            var acRegPeriod = AircraftRegistrationRequestFactory.getACRegInactivePeriod();
            setValuesToACRegPeriod(acRegPeriod);
            return acRegPeriod;
        };
        
        function setValuesToACRegPeriod(acRegPeriod) {
   		 	var currentDate = new Date();
   		    var loginInfo = ApplicationService.getLoginInfo();
   		 	if (acRegPeriod.createdBy == null) {   		 		
   		 		acRegPeriod.createdBy = loginInfo.userName;
   		 	    acRegPeriod.createdDate = moment(currentDate).format("DD/MM/YYYY");
   		 	    acRegPeriod.createdTime = moment(currentDate).format("hh:mm:ss");
   		 	}
   		 	if (acRegPeriod.acRegInactivePeriodId != null) {
   		 		acRegPeriod.modifiedBy = loginInfo.userName;
   		 		acRegPeriod.modifiedDate = moment(currentDate).format("DD/MM/YYYY");
   		 	    acRegPeriod.modifiedTime = moment(currentDate).format("hh:mm:ss");
   		 	}
			
   		 	if(!!acRegPeriod.inActiveStartDate  && moment(acRegPeriod.inActiveStartDate, "DD/MM/YYYY").isBefore(moment(currentDate))){
   		 		acRegPeriod.isPastInaStartDate = true;
   		 	}else {
   		 		acRegPeriod.isPastInaStartDate = false;
   		 	}
   		 	if(!!acRegPeriod.inActiveEndDate && moment(acRegPeriod.inActiveEndDate, "DD/MM/YYYY").isBefore(moment(currentDate))){
		 		acRegPeriod.isPastInaEndDate = true;
		 	}else{
		 		acRegPeriod.isPastInaEndDate = false;
		 	}
   		    acRegPeriod.isInaStartSetToPast = false;
   		    acRegPeriod.isInaEndSetToPast = false; 
        }
        
        self.getAircraftForEdit = function(acReg, acModelList){
            var editReg = AircraftRegistrationRequestFactory.getAcRgistrationForEdit(acReg);
            if(!!acModelList){
            	editReg.modelNumber = _.find(acModelList, {
                    modelCapacityId : editReg.aircraftModelCapacityId
                  });
            }
            angular.forEach(editReg.aircraftInactivePeriods, function (acINAPeriod) {
            	setValuesToACRegPeriod(acINAPeriod);
            });            
            return editReg; 
        };
        
        self.saveAcRegistration = function (acRegistration, successFn, errorFn) {
            var saveReg = AircraftRegistrationRequestFactory.getAcRgistrationForSave(acRegistration);
            RemoteService.saveAircraftRegistration(saveReg).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.getCapacity = function (modelNum, successFn, errorFn){
        	RemoteService.getCapacity(modelNum).then(
                    function (response) {
                    	successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
        };
        
       
        
        self.deleteAcRegistration = function (acRegistration, successFn, errorFn) {
            var deleteReg = AircraftRegistrationRequestFactory.getAcRgistrationDeleteReq(acRegistration);
            RemoteService.deleteAircraftRegistration(deleteReg).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

    }
})();